import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, Transition as _Transition, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "sm:flex sm:items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "sm:flex-auto" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-semibold leading-6 text-gray-900" }, "Flow count"),
    /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-sm text-gray-700" }, "Seçilen süreç duruma göre en çok süreç oluşturan kullanıcıları gösterir. ")
  ])
], -1)
const _hoisted_2 = { class: "mt-10" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Süreç durumu")
const _hoisted_4 = { class: "relative mt-2" }
const _hoisted_5 = { class: "block truncate" }
const _hoisted_6 = { class: "mt-8 flow-root" }
const _hoisted_7 = { class: "-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" }
const _hoisted_8 = { class: "inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8" }
const _hoisted_9 = {
  key: 0,
  class: "min-w-full divide-y divide-gray-300"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
    }, " e-Mail"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900"
    }, " Flow count")
  ])
], -1)
const _hoisted_11 = { class: "divide-y divide-gray-200 bg-white" }
const _hoisted_12 = { class: "whitespace-nowrap py-2 pl-4 pr-3 text-sm text-gray-500 sm:pl-0" }
const _hoisted_13 = { class: "whitespace-nowrap px-2 py-2 text-sm font-medium text-gray-900" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListboxLabel = _resolveComponent("ListboxLabel")!
  const _component_ListboxButton = _resolveComponent("ListboxButton")!
  const _component_ListboxOption = _resolveComponent("ListboxOption")!
  const _component_ListboxOptions = _resolveComponent("ListboxOptions")!
  const _component_Listbox = _resolveComponent("Listbox")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Listbox, {
        as: "div",
        modelValue: _ctx.selectedFlowStatus,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedFlowStatus) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ListboxLabel, { class: "block text-sm font-medium leading-6 text-gray-900" }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_ListboxButton, { class: "relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6" }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.selectedFlowStatus.displayString), 1)
              ]),
              _: 1
            }),
            _createVNode(_Transition, {
              "leave-active-class": "transition ease-in duration-100",
              "leave-from-class": "opacity-100",
              "leave-to-class": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ListboxOptions, { class: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.flowStatusEnumItems, (person) => {
                      return (_openBlock(), _createBlock(_component_ListboxOption, {
                        as: "template",
                        key: person.value,
                        value: person
                      }, {
                        default: _withCtx(({ active, selected }) => [
                          _createElementVNode("li", {
                            class: _normalizeClass([active ? 'bg-indigo-600 text-white' : 'text-gray-900', 'relative cursor-default select-none py-2 pl-3 pr-9'])
                          }, [
                            _createElementVNode("span", {
                              class: _normalizeClass([selected ? 'font-semibold' : 'font-normal', 'block truncate'])
                            }, _toDisplayString(person.displayString), 3)
                          ], 2)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_ctx.reportUserByFlowCountResult && _ctx.reportUserByFlowCountResult.items)
            ? (_openBlock(), _createElementBlock("table", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("tbody", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportUserByFlowCountResult.items, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.eMail
                    }, [
                      _createElementVNode("td", _hoisted_12, _toDisplayString(item.eMail), 1),
                      _createElementVNode("td", _hoisted_13, _toDisplayString(item.flowCount), 1)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}